/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_SorenessInputs */

const en_us2_offline_kind_soreness = /** @type {(inputs: Offline_Kind_SorenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soreness check-in`)
};

const pt_br2_offline_kind_soreness = /** @type {(inputs: Offline_Kind_SorenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in de dor muscular`)
};

const es_419_offline_kind_soreness = /** @type {(inputs: Offline_Kind_SorenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de dolor muscular`)
};

const pt_pt2_offline_kind_soreness = /** @type {(inputs: Offline_Kind_SorenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in de dor muscular`)
};

const fr_fr2_offline_kind_soreness = /** @type {(inputs: Offline_Kind_SorenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilan des courbatures`)
};

const de_de2_offline_kind_soreness = /** @type {(inputs: Offline_Kind_SorenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskelkater-Check-in`)
};

const it_it2_offline_kind_soreness = /** @type {(inputs: Offline_Kind_SorenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in indolenzimento`)
};

/**
* | output |
* | --- |
* | "Soreness check-in" |
*
* @param {Offline_Kind_SorenessInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_soreness = /** @type {((inputs?: Offline_Kind_SorenessInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_SorenessInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_soreness(inputs)
	if (locale === "es-419") return es_419_offline_kind_soreness(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_soreness(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_soreness(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_soreness(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_soreness(inputs)
	return en_us2_offline_kind_soreness(inputs)
});
export { offline_kind_soreness as "offline.kind_soreness" }